import styled from 'styled-components';
import CleaningSvg from '../../assets/amenities/cleaning.svg';

const CleaningIcon = styled(CleaningSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default CleaningIcon;
